<div class="container breadcrumbs--page-nav breadcrumbs-opeff d-none">
  <p><a [routerLink]="'/'">{{"statictext.home" | cxTranslate}}</a><span> &gt; </span><a [routerLink]="'/overview'">{{"statictext.flu360overview" | cxTranslate}}</a><span> &gt;
  </span><strong>{{"statictext.operationalefficiency" | cxTranslate}}</strong></p>
</div>
<!--coding and billing breadcrumbs-->
<div class="breadcrumbs--page-nav codingnbilling-breadcrumbs d-none">
  <div class="container">
    <p><a [routerLink]="'/'">{{"statictext.home" | cxTranslate}}</a><span> &gt; </span><a [routerLink]="'/overview'">{{"statictext.flu360overview" | cxTranslate}}</a> <span> &gt; </span><a [routerLink]="'/financial-guidance'">{{"statictext.financialguidance" | cxTranslate}}</a> <span> &gt; </span><strong>{{"statictext.codingnbilling" | cxTranslate}}</strong></p></div>
  </div>
  <!--Tools and resources breadcrumbs-->
  @if (!userLoggedIn || (userLoggedIn && (!webEnabled))) {
    <div class="breadcrumbs--page-nav tools-resource-breadcrumbs col-md-6 d-none">
      <div class="container">
        <p><a [routerLink]="'/'">{{"statictext.home" | cxTranslate}}</a><span> &gt; </span><strong>{{"statictext.toolsnresources" | cxTranslate}}</strong></p></div>
      </div>
    }
    <!--clinical-support-->
    @if ((currentSite == 'seqirusb2b-flu360') && !userLoggedIn) {
      <div class="breadcrumbs--page-nav clinical-breadcrumbs">
        <div class="container">
          <p><a [routerLink]="'/'">{{"statictext.home" | cxTranslate}}</a><span> &gt; </span><a [routerLink]="'/overview'">{{"statictext.flu360overview" | cxTranslate}}</a><span> &gt;
        </span>@if (currentPage == 'clinical-support') {
        <strong>{{"statictext.clinicalsupport" | cxTranslate}}</strong>
        }@if (currentPage == 'financial-guidance') {
        <strong>{{"statictext.financialguidance" | cxTranslate}}</strong>
      }</p>
    </div>
  </div>
}
<!--For UK Help and FAQ-->
@if ((currentSite == 'seqirusb2b-uk') && !userLoggedIn) {
  <div class="Uk-Lo-breadcrumbs">
    <div class="global_breadcrumbs_helpnfaq col-md-6 col-lg-6 col-xs-12 d-none"><span
      class="global_breadcrumblink">
      <a [routerLink]="'/'">{{"statictext.home" | cxTranslate}}</a></span>&gt;<span class="global_breadcrumbactive">{{"statictext.helpnfaq" | cxTranslate}}</span>
    </div>
  </div>
}
@if (!userLoggedIn || (userLoggedIn && (!webEnabled))) {
  <div class="outermost-div">
    @if (leftBannerNode | async ; as item) {
      <div class="container op-ef-firstcontainer op-ef-Lo-version">
        <!--operational-efficiency starting-->
        <div class="row-flex hero--circlechart opeffciency-circlechart">
          @if (item?.mediaPicture) {
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 hero--circlechart-mobile"
              >
              <img class="hero--circlechart-chart" alt="image" [src]="getImage(item.mediaPicture)">
            </div>
          }
          <div class="col-xl-8 col-lg-8 col-md-8 col-sm-12 col-xs-12 pl-hero-100">
            <div class="hero--circlechart-content">
              <img class="rectangle-down" alt="angled corner"
                src="../../../app/../assets/images/rectangle-down.svg">
                <div class="content-container">
                  <!-- <div class="container"> -->
                  <h1 [innerHTML]="item.headline"></h1>
                  <p class="text--grey-110" [innerHTML]="item.content"></p>
                  <p class="bottom_line"><strong [innerHTML]="item.h2content"></strong></p>
                  <a [routerLink]="'/createprofile'" class="create_ProfileBtn1">
                    <div class="global_greybtn">{{"statictext.createAccount" | cxTranslate}}</div>
                  </a>
                <!-- </div> -->
              </div>
            </div>
          </div>
          <div></div>
          @if (item?.mediaPicture) {
            <div class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-xs-12  hero--circlechart-desktop"
              >
              <img class="hero--circlechart-chart" alt="flu360 offerings featuring financial guidance" [src]="getImage(item.mediaPicture)">
            </div>
          }
        </div>
      </div>
    }
  </div>
}

<!--Help and faq logged In version and the overview pages Li version-->
@if (userLoggedIn && webEnabled) {
  @if (leftBannerNode | async ; as item) {
    <div class="help_LIheadersection opeff-LI-section col-xs-12" [ngStyle]="item.uid === 'seqirusMaterialBannerComponent' && item?.mediaPicture ? {'background-image': 'url(' + getImage(item?.mediaPicture) + ')'} : {}" [ngClass]="{'materials_Top_Banner': item.uid === 'seqirusMaterialBannerComponent'}">
      <div class="help-and-faq-LI d-none">
        <h1 [innerHTML]="item.headline" class="help_LIheader new_header"></h1>
        <p class="help_LIsubheader" [innerHTML]="item.content"></p>
      </div>
      @if (leftBannerNode | async ; as item) {
        <div class="container op-ef-firstcontainer opeff-LI-version" [ngClass]="{'flu_First_Comp': item.uid === 'seqirusMaterialTeaserBannerComponent'}">
          <!--operational-efficiency starting-->
          <div class="row-flex hero--circlechart opeffciency-circlechart">
            @if (item?.mediaPicture) {
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 hero--circlechart-mobile"
                >
                <img class="hero--circlechart-chart" alt="image" [src]="getImage(item.mediaPicture)">
              </div>
            }
            <div class="col-xl-8 col-lg-8 col-md-8 col-sm-12 col-xs-12 pl-hero-100">
              <div class="hero--circlechart-content">
                <img class="rectangle-down" alt="angled corner"
                  src="../../../app/../assets/images/rectangle-down.svg">
                  <div class="content-container">
                    <!-- <div class="container"> -->
                    @if (item.uids!='SeqirusLOToolsResourcesFirstComponent') {
                      @if (item.headline!='Help and FAQs') {
                        <h1  [innerHTML]="item.headline"></h1>
                      }
                    }
                    <p class="text--grey-110" [innerHTML]="item.content"></p>
                    <p class="bottom_line"><strong [innerHTML]="item.h2content"></strong></p>
                    <a [routerLink]="'/createprofile'" class="create_ProfileBtn">
                      <div class="global_greybtn">{{"statictext.createAccount" | cxTranslate}}</div>
                    </a>
                  <!-- </div> -->
                </div>
              </div>
            </div>
            <div></div>
            @if (item?.mediaPicture) {
              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-xs-12  hero--circlechart-desktop"
                >
                <img class="hero--circlechart-chart" alt="image" [src]="getImage(item.mediaPicture)">
              </div>
            }
          </div>
        </div>
      }
    </div>
  }
}































<!--operational-efficiency ends above-->

<!-- <div class="row-flex hero--circlechart" >
<div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 hero--circlechart-mobile">
  <img class="hero--circlechart-chart" alt="image" [src]="getImage(item.mediaPicture)">
</div>
<div class="col-xl-8 col-lg-8 col-md-8 col-sm-12 col-xs-12 pl-hero-100">
  <div class="hero--circlechart-content">
    <img class="rectangle-down" alt="angled corner" src="../../../app/../assets/images/rectangle-down.svg">
    <div class="content-container text-left">
      <h1>{{item.headline}}</h1>
      <p class="text-gray" [innerHTML]="item.content"></p>
      <p class="content"><strong>{{item.h2content}}</strong></p>
      <a href="/createprofile">
      </a>
    </div>
  </div>
</div>

<div class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-xs-12 hero--circlechart-desktop">

  <img class="hero--circlechart-chart" alt="image" [src]="getImage(item.mediaPicture)">
</div>
</div> -->